import { ClipboardList, Phone, CheckCircle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const steps = [
  {
    id: "step-1",
    number: "1",
    icon: ClipboardList,
    title: "Demandez votre soumission",
    description: "Remplissez notre formulaire en ligne ou appelez-nous. C'est rapide, simple et 100% gratuit.",
  },
  {
    id: "step-2",
    number: "2",
    icon: Phone,
    title: "On vous contacte rapidement",
    description: "Un membre de notre équipe vous rappelle dans les plus brefs délais pour discuter de vos besoins.",
  },
  {
    id: "step-3",
    number: "3",
    icon: CheckCircle,
    title: "Travaux réalisés avec soin",
    description: "Notre équipe se déplace et effectue les travaux avec professionnalisme. Satisfaction garantie.",
  },
];

export const HowItWorks = () => {
  const scrollToContact = () => {
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="comment-ca-marche" className="bg-white py-16 md:py-24" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-testid="how-it-works-title">
            Comment ça fonctionne
          </h2>
          <p className="text-base lg:text-lg text-gray-600 max-w-2xl mx-auto">
            Obtenir une soumission n'a jamais été aussi simple. En 3 étapes, votre terrain est entre bonnes mains.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 lg:gap-10 mb-12">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div 
                key={step.id} 
                className="relative text-center"
                data-testid={step.id}
              >
                {/* Connector line (hidden on mobile, visible on md+) */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-[#2D5A3D] to-green-200" />
                )}
                
                {/* Step content */}
                <div className="relative z-10">
                  {/* Number badge */}
                  <div className="w-24 h-24 mx-auto mb-5 relative">
                    <div className="absolute inset-0 bg-green-50 rounded-full" />
                    <div className="absolute inset-2 bg-white rounded-full shadow-sm flex items-center justify-center">
                      <Icon className="w-10 h-10 text-[#2D5A3D]" />
                    </div>
                    <div className="absolute -top-1 -right-1 w-8 h-8 bg-[#2D5A3D] rounded-full flex items-center justify-center text-white font-bold text-sm shadow-md">
                      {step.number}
                    </div>
                  </div>
                  
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {step.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed max-w-xs mx-auto">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button 
            onClick={scrollToContact} 
            size="lg" 
            className="bg-[#2D5A3D] hover:bg-[#234A30] text-white px-8 py-3 h-auto text-base"
            data-testid="how-it-works-cta"
          >
            Commencer maintenant
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
          <p className="text-sm text-gray-500 mt-3">
            Soumission gratuite · Sans engagement · Réponse rapide
          </p>
        </div>
      </div>
    </section>
  );
};
